import { Divider, Tag, Text } from "@amzn/storm-ui";

import type { CardDetail } from "../../../../types/card";

import {
    SpaceBetweenFlexBox,
    StyledCardDynamicClamp,
    StyledCardFooter,
    StyledDescriptorContainer,
    StyledDescriptorHeading,
    StyledDescriptorText,
    StyledInsightCard,
    StyledInsightCardBody,
} from "./styles";

interface CardLayoutV2Props {
    header?: string;
    title?: string;
    subtitle?: string;
    footer?: string;
    description?: string;
    postDescription?: JSX.Element;
    dataTestId: string;
    details: CardDetail[];
    actions: JSX.Element;
    tag?: string;
}
export const CardLayoutV2: React.FC<CardLayoutV2Props> = (props) => {
    const {
        dataTestId,
        description,
        actions,
        tag,
        footer,
        header,
        subtitle,
        title,
        postDescription,
    } = props;

    return (
        <StyledInsightCard data-testid={dataTestId} padding={"medium"}>
            <StyledInsightCardBody direction={"column"}>
                <StyledDescriptorContainer style={{ container: "insightCard" }}>
                    <SpaceBetweenFlexBox>
                        <Text
                            size="small"
                            weight="bold"
                            style={{ marginBottom: 10 }}
                            data-testid={`${dataTestId}-header`}
                        >
                            {header}
                        </Text>
                        {tag && <Tag variant="beta" label={tag} />}
                    </SpaceBetweenFlexBox>
                    <StyledDescriptorHeading
                        renderAs="h5"
                        style={{ marginBottom: 5 }}
                        data-testid={`${dataTestId}-title`}
                    >
                        {title}
                    </StyledDescriptorHeading>
                    <StyledDescriptorText
                        size="small"
                        style={{ margin: 0 }}
                        data-testid={`${dataTestId}-subtitle`}
                    >
                        {subtitle}
                    </StyledDescriptorText>
                    <StyledCardDynamicClamp
                        style={{ marginTop: 10 }}
                        color="secondary"
                        data-testid={`${dataTestId}-description`}
                    >
                        {description}
                    </StyledCardDynamicClamp>
                    {postDescription && <div>{postDescription}</div>}
                </StyledDescriptorContainer>
                <StyledCardFooter>
                    <Text
                        color="tertiary"
                        size="xsmall"
                        data-testid={`${dataTestId}-footer`}
                    >
                        {footer}
                    </Text>
                    <Divider />
                    {actions}
                </StyledCardFooter>
            </StyledInsightCardBody>
        </StyledInsightCard>
    );
};
